// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18Sa3","colMin":"styles_colMin__hJd7V"};